import { HttpContextToken, HttpErrorResponse } from '@angular/common/http';

export const QUEUED_PLANTATION_DELETE = new HttpContextToken(() => false);

export function getRetryAfterDelay(error: unknown): number | undefined {
  if (!(error instanceof HttpErrorResponse) || error.status !== 429) return;
  const header = error.headers.get('Retry-After')?.trim();
  if (!header) return;
  const seconds = Number(header);
  return Number.isFinite(seconds) && seconds >= 0 ? seconds * 1000 : undefined;
}

function unwrapAngularError(error: unknown): unknown {
  if (error && typeof error === 'object') {
    if ('ngOriginalError' in error) return error.ngOriginalError;
    if ('rejection' in error) return error.rejection;
  }
  return error;
}

export function isExpectedHttpError(error: unknown): boolean {
  const original = unwrapAngularError(error);
  return (
    original instanceof HttpErrorResponse &&
    [401, 403, 429].includes(original.status)
  );
}

// Sentry's default Angular extractor replaces HTTP errors with their body,
// losing the status needed by beforeSend, including for Zone promise rejections.
export function preserveHttpError(
  error: unknown,
  defaultExtractor: (error: unknown) => unknown
): unknown {
  const original = unwrapAngularError(error);
  return original instanceof HttpErrorResponse
    ? original
    : defaultExtractor(error);
}
